export const API = process.env.REACT_APP_BACKEND_URL;

export const DOMAIN_CONFIG = {
  domium: {
    rectifyUrl: (ref) => `/api/domium/admin/documents/${ref}/rectify`,
    archivesUrl: (ref) => `/api/domium/admin/documents/${ref}/rectification-archives`,
    docTypes: {
      pack_complet: 'Pack complet (Attestation + CP + CG) — recommande',
      cp: 'Conditions Particulieres',
      cg: 'Conditions Generales',
      attestation_definitive: 'Attestation Definitive',
      attestation_provisoire: 'Attestation Provisoire',
      attestation_nominative: 'Attestation Nominative (rattachement DOS DOMIUM)',
      dossier_maitre: 'Dossier Maitre',
      attestation_draft: 'Attestation DRAFT',
    },
    fieldGroups: [
      {
        title: 'Identite du souscripteur',
        fields: [
          { key: 'identite.civilite', label: 'Civilite (M / Mme)' },
          { key: 'identite.nom', label: 'Nom (Particulier ou gerant)' },
          { key: 'identite.prenom', label: 'Prenom (Particulier ou gerant)' },
          { key: 'identite.raison_sociale', label: 'Raison sociale (Entreprise uniquement)' },
          { key: 'identite.forme_juridique', label: 'Forme juridique (SARL, SAS... — Entreprise)' },
          { key: 'identite.qualite', label: 'Qualite (Particulier / Entreprise / Promoteur)' },
          { key: 'identite.siret', label: 'SIRET (Entreprise uniquement)' },
          { key: 'identite.code_naf', label: 'Code NAF (Entreprise uniquement)' },
          { key: 'identite.representant_nom', label: 'Representant - Nom (Entreprise)' },
          { key: 'identite.representant_qualite', label: 'Representant - Qualite (Entreprise)' },
          { key: 'identite.adresse', label: "Adresse du souscripteur / maitre d'ouvrage" },
          { key: 'identite.code_postal', label: 'Code postal du souscripteur' },
          { key: 'identite.ville', label: 'Ville du souscripteur' },
          { key: 'identite.pays', label: 'Pays du souscripteur' },
          { key: 'identite.telephone', label: 'Telephone du souscripteur' },
          { key: 'identite.email', label: 'Email du souscripteur' },
        ],
      },
      {
        title: "Operation & chantier",
        fields: [
          { key: 'operation.type_operation', label: "Type d'operation" },
          { key: 'operation.type_batiment', label: 'Type de batiment' },
          { key: 'operation.destination_operation', label: "Destination de l'operation" },
          { key: 'operation.description_projet', label: "Description du projet — Nature de l'operation" },
          { key: 'operation.adresse_chantier', label: 'Adresse du chantier' },
          { key: 'operation.code_postal_chantier', label: 'Code postal chantier' },
          { key: 'operation.ville_chantier', label: 'Ville chantier' },
          { key: 'operation.pays_chantier', label: 'Pays chantier' },
          { key: 'operation.territoire', label: 'Territoire' },
          { key: 'operation.reference_permis', label: 'Reference du permis' },
          { key: 'operation.date_permis', label: 'Date du permis (YYYY-MM-DD)' },
          { key: 'operation.commune_delivrance_permis', label: 'Commune delivrance permis' },
          { key: 'operation.reference_cadastrale', label: 'Reference cadastrale' },
          { key: 'operation.date_ouverture_chantier', label: 'Date ouverture chantier (YYYY-MM-DD)' },
          { key: 'operation.date_reception_previsionnelle', label: 'Date reception previsionnelle (YYYY-MM-DD)' },
          { key: 'operation.cout_total_operation', label: 'Cout total operation (EUR)' },
          { key: 'operation.cout_global_ttc', label: 'Cout global TTC (EUR)' },
        ],
      },
      {
        title: 'Caracteristiques techniques',
        fields: [
          { key: 'technique.destination', label: 'Destination' },
          { key: 'technique.type_structure', label: 'Type de structure' },
          { key: 'technique.type_fondations', label: 'Type de fondations' },
          { key: 'technique.nombre_batiments', label: 'Nombre de batiments' },
          { key: 'technique.nombre_logements', label: 'Nombre de logements' },
          { key: 'technique.nombre_locaux_professionnels', label: 'Nombre de locaux pro' },
          { key: 'technique.nombre_niveaux', label: 'Nombre de niveaux' },
          { key: 'technique.nombre_sous_sols', label: 'Nombre de sous-sols' },
          { key: 'technique.surface_plancher', label: 'Surface plancher autorisee (m2)' },
          { key: 'technique.presence_piscine', label: 'Presence piscine (oui/non)' },
          { key: 'technique.surface_piscine', label: 'Surface piscine (m2)' },
          { key: 'technique.cout_construction_ht', label: 'Montant previsionnel des travaux (EUR)' },
          { key: 'technique.date_debut_travaux', label: 'Date debut travaux (YYYY-MM-DD)' },
          { key: 'technique.duree_travaux_mois', label: 'Duree travaux (mois)' },
        ],
      },
      {
        // V37.78 — Tous les elements du tableau "II. Caracteristiques de
        // l'operation securisee" (attestation) sont editables. Les champs
        // deja presents ailleurs (nombre de batiments, dates, montant...)
        // restent dans leurs groupes Operation/Techniques.
        title: "Tableau — II. Caracteristiques de l'operation securisee",
        fields: [
          { key: 'operation.type_construction', label: 'Type de construction' },
          { key: 'operation.type_travaux', label: 'Type de travaux' },
          { key: 'operation.clos_couvert', label: 'Clos et couvert (oui/non)' },
          { key: 'operation.base_declaration', label: 'Base de declaration (TTC / HT)' },
          { key: 'technique.nombre_piscines', label: 'Nombre de piscines' },
          { key: 'operation.presence_bungalow', label: 'Presence de bungalow (oui/non)' },
          { key: 'operation.nombre_bungalows', label: 'Nombre de bungalows' },
          { key: 'operation.presence_abri_jardin', label: "Presence d'abri de jardin (oui/non)" },
          { key: 'operation.presence_garage', label: 'Presence de garage (oui/non)' },
        ],
      },
      {
        title: 'Etudes & intervenants',
        fields: [
          { key: 'etudes.maitre_oeuvre_architecte', label: "Maitre d'oeuvre / Architecte" },
          { key: 'etudes.nom_architecte', label: "Nom de l'architecte" },
          { key: 'etudes.numero_ordre_architecte', label: "N° ordre architecte" },
          { key: 'etudes.bureau_etudes_techniques', label: 'Bureau etudes techniques' },
          { key: 'etudes.nom_bureau_etudes_structure', label: 'Nom BET structure' },
          { key: 'etudes.etude_sol_realisee', label: 'Etude de sol realisee (oui/non)' },
          { key: 'etudes.nom_bureau_etude_sol', label: 'Nom bureau etude sol' },
          { key: 'etudes.etude_assainissement', label: 'Etude assainissement (oui/non)' },
          { key: 'etudes.nom_bureau_assainissement', label: 'Nom bureau assainissement' },
        ],
      },
      {
        title: 'Tableau intervenants (jusqu\'a 6 lignes)',
        fields: [
          { key: 'intervenants.0.raison_sociale', label: 'Intervenant #1 — Raison sociale' },
          { key: 'intervenants.0.siret', label: 'Intervenant #1 — SIRET' },
          { key: 'intervenants.0.role', label: 'Intervenant #1 — Mission / lot' },
          { key: 'intervenants.0.ville', label: 'Intervenant #1 — Ville' },
          { key: 'intervenants.0.montant_devis', label: 'Intervenant #1 — Montant devis TTC (EUR)' },
          { key: 'intervenants.1.raison_sociale', label: 'Intervenant #2 — Raison sociale' },
          { key: 'intervenants.1.siret', label: 'Intervenant #2 — SIRET' },
          { key: 'intervenants.1.role', label: 'Intervenant #2 — Mission / lot' },
          { key: 'intervenants.1.ville', label: 'Intervenant #2 — Ville' },
          { key: 'intervenants.1.montant_devis', label: 'Intervenant #2 — Montant devis TTC (EUR)' },
          { key: 'intervenants.2.raison_sociale', label: 'Intervenant #3 — Raison sociale' },
          { key: 'intervenants.2.siret', label: 'Intervenant #3 — SIRET' },
          { key: 'intervenants.2.role', label: 'Intervenant #3 — Mission / lot' },
          { key: 'intervenants.2.ville', label: 'Intervenant #3 — Ville' },
          { key: 'intervenants.2.montant_devis', label: 'Intervenant #3 — Montant devis TTC (EUR)' },
          { key: 'intervenants.3.raison_sociale', label: 'Intervenant #4 — Raison sociale' },
          { key: 'intervenants.3.siret', label: 'Intervenant #4 — SIRET' },
          { key: 'intervenants.3.role', label: 'Intervenant #4 — Mission / lot' },
          { key: 'intervenants.3.montant_devis', label: 'Intervenant #4 — Montant devis TTC (EUR)' },
          { key: 'intervenants.4.raison_sociale', label: 'Intervenant #5 — Raison sociale' },
          { key: 'intervenants.4.siret', label: 'Intervenant #5 — SIRET' },
          { key: 'intervenants.4.role', label: 'Intervenant #5 — Mission / lot' },
          { key: 'intervenants.4.montant_devis', label: 'Intervenant #5 — Montant devis TTC (EUR)' },
          { key: 'intervenants.5.raison_sociale', label: 'Intervenant #6 — Raison sociale' },
          { key: 'intervenants.5.siret', label: 'Intervenant #6 — SIRET' },
          { key: 'intervenants.5.role', label: 'Intervenant #6 — Mission / lot' },
          { key: 'intervenants.5.montant_devis', label: 'Intervenant #6 — Montant devis TTC (EUR)' },
        ],
      },
      {
        title: 'Calcul & contribution',
        fields: [
          { key: 'calcul.cout_construction_ht', label: 'Cout construction HT (EUR)' },
          { key: 'calcul.contribution_ht', label: 'Contribution solidaire HT (EUR)' },
          { key: 'calcul.contribution_ttc', label: 'Contribution solidaire TTC (EUR)' },
          { key: 'calcul.taux_base', label: 'Taux de base (%)' },
          { key: 'calcul.taux_effectif', label: 'Taux effectif (%)' },
          { key: 'calcul.taux_final', label: 'Taux final (%)' },
          { key: 'calcul.coeff_batiment', label: 'Coefficient batiment' },
          { key: 'calcul.coeff_operation', label: 'Coefficient operation' },
          { key: 'calcul.coeff_territoire', label: 'Coefficient territoire' },
          { key: 'calcul.tranche_utilisee', label: 'Tranche utilisee' },
          { key: 'calcul.reduction_totale', label: 'Reduction totale (EUR)' },
        ],
      },
      {
        title: 'Coordonnees bancaires',
        fields: [
          { key: 'coordonnees_bancaires.iban', label: 'IBAN' },
          { key: 'coordonnees_bancaires.bic', label: 'BIC' },
          { key: 'coordonnees_bancaires.titulaire', label: 'Titulaire du compte' },
          { key: 'coordonnees_bancaires.banque', label: 'Banque' },
          { key: 'coordonnees_bancaires.agence', label: 'Agence' },
          { key: 'coordonnees_bancaires.adresse_banque', label: 'Adresse de la banque' },
        ],
      },
      {
        title: 'Garantie & affectation',
        fields: [
          { key: 'garantie.type', label: 'Type de garantie' },
          { key: 'garantie.plafond_avant_livraison', label: 'Plafond avant livraison (EUR)' },
          { key: 'garantie.plafond_decennale', label: 'Plafond decennale (EUR)' },
          { key: 'garantie.franchise_structure', label: 'Franchise structure (EUR)' },
          { key: 'garantie.franchise_autres', label: 'Franchise autres dommages (EUR)' },
          { key: 'affectation.cooperative', label: 'Cooperative d\'affectation' },
          { key: 'affectation.fonds', label: 'Fonds d\'affectation' },
          { key: 'affectation.numero_membre', label: 'Numero de membre' },
        ],
      },
      {
        title: 'Reception (PV & dates)',
        fields: [
          { key: 'post_reception.date_reception', label: 'Date PV reception (YYYY-MM-DD)' },
          { key: 'post_reception.reserves', label: 'Reserves PV' },
          { key: 'post_reception.observations', label: 'Observations PV' },
          { key: 'operation.date_reception_pv', label: 'Date PV (operation.date_reception_pv)' },
        ],
      },
      {
        title: 'Blocs de texte legaux DOS DOMIUM (PDF) — Avance',
        fields: [
          { key: 'texte_overrides.Article 1 — Nature du cadre DOS DOMIUM', label: 'Titre — Article 1 (Nature du cadre)' },
          { key: 'texte_overrides.Article 2 — Références et fondements', label: 'Titre — Article 2 (Refs & fondements)' },
          { key: 'texte_overrides.Article 3 — Objet', label: 'Titre — Article 3 (Objet)' },
          { key: "texte_overrides.Article 4 — Territorialité et champ d’éligibilité du cadre DOS DOMIUM", label: 'Titre — Article 4 (Territorialite & eligibilite)' },
          { key: 'texte_overrides.Article 5 — Cas de non-intervention du dispositif solidaire', label: 'Titre — Article 5 (Cas non-intervention)' },
          { key: "texte_overrides.Article 6 — Organes et écosystème d’intervention", label: 'Titre — Article 6 (Organes & ecosysteme)' },
          { key: "texte_overrides.Article 7 — Processus d’analyse et de décision", label: "Titre — Article 7 (Processus d'analyse)" },
          { key: "texte_overrides.Article 8 — Modalités d’intervention", label: "Titre — Article 8 (Modalites d'intervention)" },
          { key: "texte_overrides.Article 9 — Intervenants à l’opération", label: "Titre — Article 9 (Intervenants)" },
          { key: "texte_overrides.Article 10 — Obligations du maître d'ouvrage (ou son représentant) en cas de dommage", label: "Titre — Article 10 (Obligations MO)" },
          { key: "texte_overrides.Article 11 — Contribution solidaire et participation au fonds", label: 'Titre — Article 11 (Contribution solidaire)' },
          { key: 'texte_overrides.Article 12 — Révision des contributions et des plafonds', label: 'Titre — Article 12 (Revision contributions)' },
          { key: 'texte_overrides.Article 13 — Collaboration et recours solidaire', label: 'Titre — Article 13 (Collaboration & recours)' },
          { key: "texte_overrides.Article 14 — Coordination avec d’autres dispositifs de couverture", label: 'Titre — Article 14 (Coordination)' },
          { key: 'texte_overrides.Article 15 — Protection des données à caractère personnel', label: 'Titre — Article 15 (RGPD)' },
          { key: "texte_overrides.Article 16 — Formation et durée de l’adhésion", label: "Titre — Article 16 (Formation & duree)" },
          { key: "texte_overrides.Article 17 — Suspension ou cessation d’adhésion", label: 'Titre — Article 17 (Suspension / cessation)' },
          { key: 'texte_overrides.Article 18 — Participation solidaire du membre', label: 'Titre — Article 18 (Participation solidaire)' },
          { key: 'texte_overrides.Article 19 — Manquements, sanctions et mesures de suspension', label: 'Titre — Article 19 (Sanctions)' },
          { key: 'texte_overrides.Article 20 — Clause de qualification juridique finale', label: 'Titre — Article 20 (Qualification juridique)' },
          { key: 'texte_overrides.I. Identification du maître d’ouvrage', label: "Titre — Section I (Identification MO)" },
          { key: "texte_overrides.II. Caractéristiques de l’opération sécurisée", label: 'Titre — Section II (Caracteristiques operation)' },
          { key: 'texte_overrides.Descriptif du projet', label: 'Titre — Descriptif du projet' },
          { key: "texte_overrides.Intervenants à l’opération", label: "Titre — Intervenants a l'operation" },
          { key: "texte_overrides.Cadre de capacité d’intervention technique et financière applicable à l’opération", label: "Titre — Cadre capacite d'intervention" },
          { key: 'texte_overrides.Bloc de signature et vérification', label: 'Titre — Bloc signature & verification' },
          { key: 'texte_overrides.Note de lecture plateforme et vérification', label: 'Titre — Note de lecture plateforme' },
          { key: "texte_overrides.Schéma contractuel de sécurisation et de lecture de l’opération", label: "Titre — Schema contractuel" },
          { key: 'texte_overrides.Modèle de déclaration de dommage — DOS DOMIUM', label: 'Titre — Modele declaration dommage' },
          { key: 'texte_overrides.Annexe I — Formulaire de déclaration solidaire', label: 'Titre — Annexe I (Formulaire)' },
        ],
      },
    ],
    archiveField: 'rectification_archive_for',
  },
  rcds: {
    rectifyUrl: (ref) => `/api/rcds-dashboard/admin/souscriptions/${ref}/rectify`,
    archivesUrl: (ref) => `/api/rcds-dashboard/admin/souscriptions/${ref}/rectification-archives`,
    docTypes: {
      rcds_attestation: 'Attestation RCDS',
      rcds_pack_unique: 'Pack unifie RCDS (Attestation + CP + CG)',
    },
    fieldGroups: [
      {
        title: 'Entreprise — Identité',
        fields: [
          { key: 'raison_sociale', label: 'Raison sociale' },
          { key: 'siret', label: 'SIRET' },
          { key: 'code_naf', label: 'Code NAF / APE' },
          { key: 'forme_juridique', label: 'Forme juridique (SARL, SAS…)' },
          { key: 'statut_juridique', label: 'Statut juridique' },
          { key: 'date_creation_entreprise', label: 'Date de création (YYYY-MM-DD)' },
          { key: 'site_web', label: 'Site web' },
        ],
      },
      {
        title: 'Entreprise — Adresse & contact',
        fields: [
          { key: 'adresse_entreprise', label: 'Adresse entreprise' },
          { key: 'code_postal', label: 'Code postal' },
          { key: 'ville', label: 'Ville' },
          { key: 'pays', label: 'Pays' },
          { key: 'pays_code', label: 'Code pays (ISO)' },
          { key: 'telephone', label: 'Téléphone' },
          { key: 'telephone_indicatif', label: 'Indicatif téléphonique (+33, +590…)' },
          { key: 'email', label: 'Email' },
        ],
      },
      {
        title: 'Représentant légal',
        fields: [
          { key: 'nom_gerant', label: 'Nom du gérant' },
          { key: 'prenom_gerant', label: 'Prénom du gérant' },
          { key: 'fonction_gerant', label: 'Fonction (Gérant, Président…)' },
        ],
      },
      {
        title: 'Couverture & souscription',
        fields: [
          { key: 'type_souscription', label: 'Type (annuel / nominative)' },
          { key: 'territoire', label: 'Territoire' },
          { key: 'territoire_id', label: 'ID territoire (metropole, antilles…)' },
          { key: 'effectif', label: 'Effectif (nombre)' },
          { key: 'chiffre_affaires', label: "Chiffre d'affaires (EUR)" },
          { key: 'date_debut', label: 'Date début (YYYY-MM-DD)' },
          { key: 'date_fin', label: 'Date fin (YYYY-MM-DD)' },
          { key: 'periode_adhesion_debut', label: 'Période adhésion début (DD/MM/YYYY)' },
          { key: 'periode_adhesion_fin', label: 'Période adhésion fin (DD/MM/YYYY)' },
          { key: 'motif_avenant', label: 'Motif avenant' },
        ],
      },
      {
        title: 'Tarification (sous-objet)',
        fields: [
          { key: 'tarification.ca_ht', label: "CA HT (tarification.ca_ht)" },
          { key: 'tarification.montant_ht', label: 'Montant HT (tarification.montant_ht)' },
          { key: 'tarification.montant_ttc', label: 'Montant TTC (tarification.montant_ttc)' },
          { key: 'tarification.montant_contribution_ht', label: 'Contribution HT (tarification.montant_contribution_ht)' },
          { key: 'tarification.montant_tva', label: 'Montant TVA (tarification.montant_tva)' },
          { key: 'tarification.plafond_avant_livraison', label: 'Plafond avant livraison' },
          { key: 'tarification.plafond_decennale', label: 'Plafond décennale' },
          { key: 'tarification.franchise_structure', label: 'Franchise structure' },
          { key: 'tarification.franchise_autres', label: 'Franchise autres dommages' },
          { key: 'tarification.date_debut', label: 'Date début couverture (tarification.date_debut)' },
          { key: 'tarification.date_fin', label: 'Date fin couverture (tarification.date_fin)' },
        ],
      },
      {
        title: "Identification de l'opération (Nominative)",
        fields: [
          { key: 'operation_nominative.type_operation', label: "Type d'opération (construction_neuve, rehab…)" },
          { key: 'operation_nominative.description_operation', label: "Description de l'opération" },
          { key: 'operation_nominative.adresse_operation', label: "Adresse de l'opération" },
          { key: 'operation_nominative.code_postal_operation', label: 'Code postal opération' },
          { key: 'operation_nominative.ville_operation', label: 'Ville opération' },
          { key: 'operation_nominative.pays_operation', label: 'Pays opération' },
          { key: 'operation_nominative.territoire_intervention', label: "Territoire d'intervention (dom, metropole…)" },
          { key: 'operation_nominative.reference_operation', label: 'Référence opération' },
          { key: 'operation_nominative.date_debut_chantier', label: 'Date début chantier (YYYY-MM-DD)' },
          { key: 'operation_nominative.date_fin_chantier', label: 'Date fin chantier (YYYY-MM-DD)' },
          { key: 'operation_nominative.cout_total_previsionnel', label: 'Coût total prévisionnel (EUR HT)' },
          { key: 'operation_nominative.montant_base_chantier', label: 'Montant de base chantier (EUR)' },
        ],
      },
      {
        title: "Maître d'ouvrage (Nominative)",
        fields: [
          { key: 'maitre_ouvrage.type', label: 'Type MO (particulier / professionnel)' },
          { key: 'maitre_ouvrage.raison_sociale', label: 'MO — Raison sociale (Pro)' },
          { key: 'maitre_ouvrage.siret', label: 'MO — SIRET' },
          { key: 'maitre_ouvrage.nom', label: 'MO — Nom (Particulier)' },
          { key: 'maitre_ouvrage.prenom', label: 'MO — Prénom (Particulier)' },
          { key: 'maitre_ouvrage.adresse', label: 'MO — Adresse' },
          { key: 'maitre_ouvrage.code_postal', label: 'MO — Code postal' },
          { key: 'maitre_ouvrage.ville', label: 'MO — Ville' },
          { key: 'maitre_ouvrage.pays', label: 'MO — Pays' },
          { key: 'maitre_ouvrage.telephone', label: 'MO — Téléphone' },
          { key: 'maitre_ouvrage.email', label: 'MO — Email' },
        ],
      },
      {
        title: "Intervenants & maître d'œuvre",
        fields: [
          { key: 'intervenants.maitre_oeuvre_nom', label: "Maître d'œuvre — Nom" },
          { key: 'intervenants.maitre_oeuvre_qualite', label: "Maître d'œuvre — Qualité" },
          { key: 'intervenants.architecte_nom', label: 'Architecte — Nom' },
          { key: 'intervenants.architecte_numero_ordre', label: 'Architecte — N° ordre' },
          { key: 'intervenants.bet_structure_nom', label: 'Bureau études (BET) — Structure' },
          { key: 'intervenants.bet_fluides_nom', label: 'Bureau études (BET) — Fluides' },
          { key: 'intervenants.bureau_etude_sol_nom', label: "Bureau d'étude de sol — Nom" },
          { key: 'intervenants.controleur_technique', label: 'Contrôleur technique' },
          { key: 'intervenants.coordonnateur_sps', label: 'Coordonnateur SPS' },
          { key: 'intervenants.role_entreprise', label: 'Rôle de l\'entreprise (entreprise générale, sous-traitant…)' },
        ],
      },
      {
        title: 'Coordonnées bancaires',
        fields: [
          { key: 'coordonnees_bancaires.iban', label: 'IBAN' },
          { key: 'coordonnees_bancaires.bic', label: 'BIC' },
          { key: 'coordonnees_bancaires.titulaire', label: 'Titulaire du compte' },
          { key: 'coordonnees_bancaires.banque', label: 'Banque' },
          { key: 'coordonnees_bancaires.agence', label: 'Agence' },
          { key: 'coordonnees_bancaires.adresse_banque', label: 'Adresse de la banque' },
        ],
      },
      {
        title: 'Contribution & calcul détaillé',
        fields: [
          { key: 'cout_total_operation', label: "Coût total opération (EUR HT, racine)" },
          { key: 'montant_ht_contribution', label: 'Montant HT contribution (racine)' },
          { key: 'montant_ht', label: 'Montant HT (racine)' },
          { key: 'montant_global_fige', label: 'Montant global figé' },
          { key: 'tarification.nb_activites', label: "Nombre d'activités tarifées" },
          { key: 'tarification.detail_calcul', label: 'Détail calcul (JSON / texte)' },
          { key: 'tarification.coefficients_utilises', label: 'Coefficients utilisés (JSON)' },
        ],
      },
      {
        title: 'Activités & dispositifs',
        fields: [
          { key: 'activites_selectionnees', label: "Catégories d'activités sélectionnées (liste)" },
          { key: 'categorie_metier', label: 'Catégorie métier (gros_oeuvre…)' },
        ],
      },
      {
        title: 'Période personnalisée',
        fields: [
          { key: 'periode_personnalisee.date_debut', label: 'Période perso — Date début (YYYY-MM-DD)' },
          { key: 'periode_personnalisee.date_fin', label: 'Période perso — Date fin (YYYY-MM-DD)' },
          { key: 'nombre_jours', label: 'Nombre de jours de couverture' },
          { key: 'date_effet', label: "Date d'effet (YYYY-MM-DD)" },
        ],
      },
      {
        title: 'Références internes',
        fields: [
          { key: 'numero_adherent', label: 'Numéro adhérent' },
          { key: 'ref_solidaire', label: 'Référence solidaire (SOL-…)' },
        ],
      },
      {
        title: 'Notes & commentaires',
        fields: [
          { key: 'notes', label: 'Notes internes' },
        ],
      },
      {
        title: 'Tableau intervenants / sous-traitants (jusqu\'à 6 lignes)',
        fields: [
          { key: 'intervenants.0.raison_sociale', label: 'Intervenant #1 — Raison sociale' },
          { key: 'intervenants.0.siret', label: 'Intervenant #1 — SIRET' },
          { key: 'intervenants.0.role', label: 'Intervenant #1 — Mission / lot' },
          { key: 'intervenants.0.ville', label: 'Intervenant #1 — Ville' },
          { key: 'intervenants.0.montant_devis', label: 'Intervenant #1 — Montant devis TTC (EUR)' },
          { key: 'intervenants.1.raison_sociale', label: 'Intervenant #2 — Raison sociale' },
          { key: 'intervenants.1.siret', label: 'Intervenant #2 — SIRET' },
          { key: 'intervenants.1.role', label: 'Intervenant #2 — Mission / lot' },
          { key: 'intervenants.1.montant_devis', label: 'Intervenant #2 — Montant devis TTC (EUR)' },
          { key: 'intervenants.2.raison_sociale', label: 'Intervenant #3 — Raison sociale' },
          { key: 'intervenants.2.siret', label: 'Intervenant #3 — SIRET' },
          { key: 'intervenants.2.role', label: 'Intervenant #3 — Mission / lot' },
          { key: 'intervenants.2.montant_devis', label: 'Intervenant #3 — Montant devis TTC (EUR)' },
          { key: 'intervenants.3.raison_sociale', label: 'Intervenant #4 — Raison sociale' },
          { key: 'intervenants.3.siret', label: 'Intervenant #4 — SIRET' },
          { key: 'intervenants.3.role', label: 'Intervenant #4 — Mission / lot' },
          { key: 'intervenants.3.montant_devis', label: 'Intervenant #4 — Montant devis TTC (EUR)' },
          { key: 'intervenants.4.raison_sociale', label: 'Intervenant #5 — Raison sociale' },
          { key: 'intervenants.4.siret', label: 'Intervenant #5 — SIRET' },
          { key: 'intervenants.4.role', label: 'Intervenant #5 — Mission / lot' },
          { key: 'intervenants.4.montant_devis', label: 'Intervenant #5 — Montant devis TTC (EUR)' },
          { key: 'intervenants.5.raison_sociale', label: 'Intervenant #6 — Raison sociale' },
          { key: 'intervenants.5.siret', label: 'Intervenant #6 — SIRET' },
          { key: 'intervenants.5.role', label: 'Intervenant #6 — Mission / lot' },
          { key: 'intervenants.5.montant_devis', label: 'Intervenant #6 — Montant devis TTC (EUR)' },
        ],
      },
      {
        title: "Tableau chiffre d'affaires par territoire (vide = inchangé, 0 = ligne supprimée, total recalculé)",
        fields: [
          { key: 'territoires_ca.guadeloupe', label: 'CA HT — Guadeloupe (EUR)' },
          { key: 'territoires_ca.martinique', label: 'CA HT — Martinique (EUR)' },
          { key: 'territoires_ca.guyane', label: 'CA HT — Guyane (EUR)' },
          { key: 'territoires_ca.reunion', label: 'CA HT — La Réunion (EUR)' },
          { key: 'territoires_ca.mayotte', label: 'CA HT — Mayotte (EUR)' },
          { key: 'territoires_ca.saint_martin', label: 'CA HT — Saint-Martin (EUR)' },
          { key: 'territoires_ca.saint_barthelemy', label: 'CA HT — Saint-Barthélemy (EUR)' },
          { key: 'territoires_ca.metropole', label: 'CA HT — Métropole (EUR)' },
        ],
      },

      {
        title: 'Blocs de texte légaux RCDS — Curated (titres et paragraphes amont)',
        fields: [
          { key: 'texte_overrides.operation_section_title', label: "Titre de section : Identification de l'opération" },
          { key: 'texte_overrides.mo_section_title', label: "Titre de section : Maître d'ouvrage" },
          { key: 'texte_overrides.contribution_section_title', label: 'Titre de section : Contribution chantier' },
          { key: 'texte_overrides.contribution_chantier_intro', label: "Paragraphe d'intro « Le montant de base constitue une référence opérationnelle… » (Contribution chantier)" },
          { key: 'texte_overrides.scope_section_title', label: "Titre de section : Capacités d'intervention / Désignation de l'opération" },
          { key: 'texte_overrides.scope_section_note', label: "Note sous le titre (HTML autorisé, ex : <p class='small'>…</p>)" },
          { key: 'texte_overrides.scope_help_text', label: "Texte d'aide additionnel sous le titre périmètre" },
          { key: 'texte_overrides.technique_note', label: "Note technique finale (paragraphe explicatif du périmètre)" },
        ],
      },
      {
        title: 'Attestation RCDS — Articles 1 à 16 (titres litteraux)',
        fields: [
          { key: 'texte_overrides.Article 1 — Qualification du cadre', label: 'Titre — Article 1 (Qualification du cadre)' },
          { key: 'texte_overrides.Article 2 — Fondements juridiques', label: 'Titre — Article 2 (Fondements juridiques)' },
          { key: 'texte_overrides.Article 3 — Principes directeurs', label: 'Titre — Article 3 (Principes directeurs)' },
          { key: "texte_overrides.Article 4 — Champ des entreprises et opérations concernées", label: 'Titre — Article 4 (Champ entreprises & opérations)' },
          { key: "texte_overrides.Article 5 — Définition du champ d’intervention", label: "Titre — Article 5 (Définition du champ d'intervention)" },
          { key: 'texte_overrides.Article 6 — Territorialité', label: 'Titre — Article 6 (Territorialité)' },
          { key: "texte_overrides.Article 7 — Conditions d’éligibilité", label: "Titre — Article 7 (Conditions d'éligibilité)" },
          { key: 'texte_overrides.Article 8 — Travaux, produits et procédés éligibles', label: 'Titre — Article 8 (Travaux & procédés éligibles)' },
          { key: "texte_overrides.Article 9 — Modalités d’intervention", label: "Titre — Article 9 (Modalités d'intervention)" },
          { key: "texte_overrides.Article 10 — Portée des capacités d’intervention", label: 'Titre — Article 10 (Portée des capacités)' },
          { key: 'texte_overrides.Article 11 — Gouvernance', label: 'Titre — Article 11 (Gouvernance)' },
          { key: "texte_overrides.Article 12 — Obligations de l’entreprise", label: "Titre — Article 12 (Obligations de l'entreprise)" },
          { key: "texte_overrides.Article 13 — Coobligation et pluralité d’intervenants", label: 'Titre — Article 13 (Coobligation & pluralité)' },
          { key: 'texte_overrides.Article 14 — Durée', label: 'Titre — Article 14 (Durée)' },
          { key: 'texte_overrides.Article 15 — Dispositions finales', label: 'Titre — Article 15 (Dispositions finales)' },
          { key: 'texte_overrides.Article 16 — Signature, vérification et authentification', label: 'Titre — Article 16 (Signature & vérification)' },
        ],
      },
      {
        title: 'Attestation RCDS — Blocs structurels',
        fields: [
          { key: 'texte_overrides.ATTESTATION DE CAPACITÉ TECHNIQUE ET FINANCIÈRE', label: 'Titre principal (page de garde Attestation)' },
          { key: 'texte_overrides.Identité et références', label: 'Bloc — Identité et références' },
          { key: "texte_overrides.Capacités d'intervention", label: "Bloc — Capacités d'intervention" },
          { key: "texte_overrides.Capacité de mobilisation", label: "Bloc — Capacité de mobilisation" },
          { key: 'texte_overrides.Architecture financière', label: 'Bloc — Architecture financière' },
          { key: 'texte_overrides.Appréciation des capacités', label: 'Bloc — Appréciation des capacités' },
          { key: 'texte_overrides.Bloc signature institutionnel', label: 'Bloc — Signature institutionnel' },
          { key: 'texte_overrides.Bloc signature', label: 'Bloc — Signature' },
          { key: 'texte_overrides.Vérification', label: 'Bloc — Vérification' },
          { key: 'texte_overrides.Cadre de mobilisation', label: 'Bloc — Cadre de mobilisation' },
          { key: 'texte_overrides.Synthèse institutionnelle', label: 'Bloc — Synthèse institutionnelle' },
          { key: 'texte_overrides.Synthèse opérationnelle', label: 'Bloc — Synthèse opérationnelle' },
          { key: 'texte_overrides.Décision de mobilisation', label: 'Bloc — Décision de mobilisation' },
          { key: 'texte_overrides.Note de lecture', label: 'Bloc — Note de lecture' },
          { key: 'texte_overrides.Lecture financière synthétique', label: 'Bloc — Lecture financière synthétique' },
          { key: 'texte_overrides.Lecture pour les partenaires financiers', label: 'Bloc — Lecture pour partenaires financiers' },
          { key: 'texte_overrides.Gouvernance financière', label: 'Bloc — Gouvernance financière' },
          { key: 'texte_overrides.Structure opérationnelle', label: 'Bloc — Structure opérationnelle' },
        ],
      },
      {
        title: 'Conditions Particulières (CP) — Titres de section',
        fields: [
          { key: 'texte_overrides.1. Nature du cadre', label: 'CP — 1. Nature du cadre' },
          { key: "texte_overrides.1. Objet des CP", label: '   1. Objet des CP' },
          { key: 'texte_overrides.2. Fondement juridique', label: 'CP — 2. Fondement juridique' },
          { key: "texte_overrides.2. Périmètre d'application", label: "CP — 2. Périmètre d'application" },
          { key: 'texte_overrides.3. Finalité', label: 'CP — 3. Finalité' },
          { key: 'texte_overrides.4. Capacités indicatives', label: 'CP — 4. Capacités indicatives' },
          { key: 'texte_overrides.4. Positionnement opérationnel', label: 'CP — 4. Positionnement opérationnel' },
          { key: "texte_overrides.5. Engagements de l'entreprise", label: "CP — 5. Engagements de l'entreprise" },
          { key: "texte_overrides.5. Modalités d'intervention", label: "CP — 5. Modalités d'intervention" },
          { key: 'texte_overrides.6. Conditions de mise en oeuvre', label: 'CP — 6. Conditions de mise en œuvre' },
          { key: 'texte_overrides.6. Durée', label: 'CP — 6. Durée' },
          { key: 'texte_overrides.7. Limites', label: 'CP — 7. Limites' },
          { key: 'texte_overrides.8. Compatibilité marché public', label: 'CP — 8. Compatibilité marché public' },
          { key: 'texte_overrides.Identification de l\'entreprise', label: "CP — Identification de l'entreprise" },
          { key: 'texte_overrides.Conditions particulières (CP)', label: 'CP — Sous-titre "Conditions particulières (CP)"' },
          { key: 'texte_overrides.Conditions particulières et conditions générales', label: 'CP — En-tête combinée CP+CG' },
        ],
      },
      {
        title: 'Conditions Générales (CG) — Titres de section',
        fields: [
          { key: 'texte_overrides.Conditions générales (CG)', label: 'CG — Sous-titre "Conditions générales (CG)"' },
          { key: 'texte_overrides.Objet des conditions générales', label: 'CG — Objet des conditions générales' },
          { key: 'texte_overrides.Préambule contractuel', label: 'CG — Préambule contractuel' },
          { key: 'texte_overrides.Références contractuelles', label: 'CG — Références contractuelles' },
          { key: 'texte_overrides.Principe général', label: 'CG — Principe général' },
          { key: 'texte_overrides.Fondement juridique', label: 'CG — Fondement juridique' },
          { key: 'texte_overrides.Principes de soutenabilité', label: 'CG — Principes de soutenabilité' },
          { key: "texte_overrides.Modalités d’intervention", label: "CG — Modalités d'intervention" },
          { key: "texte_overrides.Conditions d’activation", label: "CG — Conditions d'activation" },
          { key: "texte_overrides.Territorialité d'application", label: "CG — Territorialité d'application" },
          { key: 'texte_overrides.Compatibilité marché', label: 'CG — Compatibilité marché' },
          { key: 'texte_overrides.Positionnement opérationnel et assurantiel', label: 'CG — Positionnement opérationnel & assurantiel' },
          { key: 'texte_overrides.Positionnement marché', label: 'CG — Positionnement marché' },
          { key: 'texte_overrides.Portée financière du mécanisme', label: 'CG — Portée financière du mécanisme' },
          { key: 'texte_overrides.Instruction', label: 'CG — Instruction' },
          { key: 'texte_overrides.Finalités de la mobilisation', label: 'CG — Finalités de la mobilisation' },
          { key: 'texte_overrides.Dispositions complémentaires', label: 'CG — Dispositions complémentaires' },
          { key: 'texte_overrides.Signature, vérification et opposabilité', label: 'CG — Signature, vérification & opposabilité' },
          { key: 'texte_overrides.Objet de l’annexe', label: "CG — Objet de l'annexe" },
        ],
      },
    ],
    archiveField: 'rectification_archive_for',
  },
};

// V37.89 — Champs EXACTS du document « Attestation nominative de
// rattachement DOS DOMIUM — Dommages à l'ouvrage » (PDF 5 pages), dans
// l'ordre du document : I. Identification du maître d'ouvrage,
// II. Chantier concerné. Utilisé par le filtre rapide « Attestation
// nominative » (auto-activé quand ce type de document est sélectionné).
export const NOMINATIVE_FIELD_KEYS = [
  // I. Identification du maître d'ouvrage
  'identite.civilite', 'identite.nom', 'identite.prenom', 'identite.raison_sociale',
  'identite.qualite', 'identite.adresse', 'identite.code_postal', 'identite.ville',
  'operation.territoire', 'identite.email', 'identite.telephone',
  // II. Chantier concerné
  'operation.description_projet', 'operation.adresse_chantier',
  'operation.reference_permis', 'operation.reference_cadastrale',
  'operation.date_ouverture_chantier', 'operation.date_reception_previsionnelle',
  'technique.surface_plancher', 'technique.cout_construction_ht',
  'operation.base_declaration',
];

// V37.91 — Validation visuelle des champs NUMÉRIQUES pendant la saisie
// (miroir de NUMERIC_FIELD_NAMES côté backend, domium_document_rectify.py).
export const NUMERIC_FIELD_LASTS = new Set([
  'cout_construction_ht', 'cout_total_operation', 'cout_global_ttc',
  'contribution_ht', 'contribution_ttc', 'prime_totale',
  'taux_base', 'taux_effectif', 'taux_final',
  'coeff_batiment', 'coeff_operation', 'coeff_territoire',
  'reduction_totale', 'montant_devis',
  'surface_plancher', 'surface_piscine',
  'plafond_avant_livraison', 'plafond_decennale',
  'franchise_structure', 'franchise_autres',
  'nombre_batiments', 'nombre_logements', 'nombre_locaux_professionnels',
  'nombre_niveaux', 'nombre_sous_sols', 'nombre_piscines',
  'nombre_bungalows', 'duree_travaux_mois',
]);

export const numericKindOf = (key) => {
  if (key.startsWith('territoires_ca.')) return 'money';
  const last = key.split('.').pop();
  if (!NUMERIC_FIELD_LASTS.has(last)) return null;
  if (last.startsWith('nombre_') || last.startsWith('duree_')) return 'count';
  if (last.startsWith('surface_')) return 'surface';
  if (last.startsWith('taux') || last.startsWith('coeff') || last.startsWith('reduction')) return 'rate';
  return 'money';
};

export const parseFrNumber = (raw) => {
  if (raw === undefined || raw === null) return null;
  if (typeof raw === 'number') return raw;
  let t = String(raw).replace(/[^\d,.-]/g, '');
  if (!t) return null;
  if (t.includes(',') && t.includes('.')) {
    const dec = t.lastIndexOf(',') > t.lastIndexOf('.') ? ',' : '.';
    t = t.split(dec === ',' ? '.' : ',').join('').replace(',', '.');
  } else if (t.includes(',')) {
    t = (t.match(/,/g) || []).length === 1 ? t.replace(/\./g, '').replace(',', '.') : t.replace(/,/g, '');
  } else if ((t.match(/\./g) || []).length > 1 || /^-?\d{1,3}(\.\d{3})+$/.test(t)) {
    t = t.replace(/\./g, '');
  }
  return Number(t);
};

export const formatFrNumber = (n, kind) => {
  if (kind === 'money') return `${new Intl.NumberFormat('fr-FR', { minimumFractionDigits: 2, maximumFractionDigits: 2 }).format(n)} €`;
  if (kind === 'surface') return `${new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 2 }).format(n)} m²`;
  return new Intl.NumberFormat('fr-FR', { maximumFractionDigits: 4 }).format(n);
};
